export default {
	methods: 
    {	
		getPdf()
		{
			let asesor=this.searchSw.value
			window.open( this.url+'/api/pdf/comisiones?mes='+this.mes_periodo.id+'&ano='+this.ano_periodo.id+'&asesor='+asesor+'&token='+this.token,'_blank')
		},
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {				
				if(filterKeys[i]==='inicial')
				{
					(this.filter.inicial==='') ? dataRoute.inicial= this.fecha().inicioLabores.servicios : dataRoute.inicial= this.filter.inicial;
					
				}		
				if(filterKeys[i]==='final')
				{
					(this.filter.final==='') ? dataRoute.final= this.fecha().inicioLabores.servicios : dataRoute.final= this.filter.final;
				}	
				if(filterKeys[i]!=='inicial' && filterKeys[i]!=='final' && this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					others.push([filterKeys[i],this.filter[filterKeys[i]].id ])
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_aportesinformes', data: dataRoute})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		},	
		async getLimpiar()
		{
			this.filter = {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null,
				id_datos_razon: null
			}
			await this.getDataGet({ route: 'get_aportesinformes', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
		}	
	},
}